export const category = [
  "Marketing Management",
  "Social Media Marketing",
  "Creative Copywriting",
  "Facebook Ads",
  "Youtube Ads",
  "Influencer and Community Marketing",
  "Search Engine Optimization",
];
